<template>
    <div class="container mt-5 pt-5">
        <div class="h1 text-center"><strong>結帳</strong></div>
        <div class="row mt-3">
            <div class="col-12 col-md">
                <div class="alert alert-success alert-rounded text-center" role="alert">輸入訂單資料</div>
            </div>
        </div>
        <div class="row justify-content-center mt-4">
            <div class="col-md-8">
                <cart-list></cart-list>

                <div class="card text-center my-5 border-0">
                    <div class="card-header border-0">
                        <div class="h3 mt-1"> 訂購人資訊 </div>
                    </div>
                    <form class="needs-validation" style="background-color: #f9f9f9 !important"
                        @submit.prevent="submit">
                        <div class="form-row text-left mt-3">
                            <div class="form-group col-md-6">
                                <label for="name">姓名</label>
                                <input type="text" class="form-control " id="name" v-model="orderData.name"
                                    placeholder="姓名" required>
                                <div class="invalid-feedback">請填寫姓名</div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="phone">手機</label>
                                <input type="phone" class="form-control" id="phone" v-model="orderData.phone"
                                    placeholder="手機號碼" required>
                                <div class="invalid-feedback">請填寫Email</div>
                            </div>
                        </div>
                        <div class="form-row text-left">
                            <div class="form-group col-md-4">
                                <label for="city">住址</label>
                                <select id="city" class="form-control" v-model="cityId">
                                    <option v-for="(city, index) in cities" :key="index" :value="city.id"
                                        v-text="city.name_of"></option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="dist">地區</label>
                                <select id="dist" v-model="orderData.dist_id" class="form-control">
                                    <option v-for="(adminDivision, index) in adminDivisions" :key="index"
                                        :value="adminDivision.id" v-text="adminDivision.name_of"></option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="postal-code">郵遞區號</label>
                                <input type="text" class="form-control" v-model="zipcode">
                            </div>
                        </div>
                        <div class="form-row">
                            <label for="address">地址</label>
                            <input type="text" class="form-control" id="mail" v-model="orderData.address"
                                placeholder="一路123號" required>
                        </div>
                        <div class="card-header border-0 mt-3">
                            <div class="h3 mt-1"> 選擇付款方式</div>
                        </div>
                        <div class="row" style="padding: 0.75rem 1.25rem;">
                            <div class="form-check col-md-6">
                                <input class="form-check-input" type="radio" v-model="orderData.payment"
                                    name="exampleRadios" id="exampleRadios1" value="ALL" checked>
                                <label class="form-check-label" for="exampleRadios1" style="width: 35%; margin:0 auto;">
                                    信用卡
                                    <div >
                                        <img :src="`${base_url}/files/images/card.png`" alt="">
                                    </div>
                                </label>
                            </div>
                            <div class="form-check col-md-6">
                                <input class="form-check-input" type="radio" v-model="orderData.payment"
                                    name="exampleRadios" id="exampleRadios2" value="atm">
                                <label class="form-check-label" for="exampleRadios2" style="width: 35%; margin:0 auto;">
                                    A T M
                                <div>
                                    <img :src="`${base_url}/files/images/atm.png`" alt="">
                                </div>
                                </label>
                            </div>
                        </div>

                        <div class="mt-3 d-flex justify-content-end">
                            <a onclick="history.back()" class="btn btn-secondary mr-2">繼續選購</a>
                            <button type="submit" class="btn btn-primary">確認付款</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import eventHub from '../library/eventHub';
import ApiBase from './components/ApiBase';

export default {
    extends: ApiBase,
    props: {
        previous: {
            default: `${base_url}`
        }
    },
    watch: {
        cityId(newValue, oldValue) {
            this.loadAdminDivision(newValue);
        }
    },
    data() {
        return {
            base_url,
            cityId: undefined,
            cities: [],
            adminDivisions: [],
            orderData: {
                dist_id: undefined,
                name: undefined,
                phone: undefined,
                address: undefined,
                payment: undefined
            }
        }
    },
    mounted() {
        if (!eventHub.$data.cartCount) {
            this.$swal({
                title: '購物車是空的',
                willClose: () => {
                    window.Turbolinks.visit(this.previous);
                }
            });
        } else {
            this.initData();
            this.loadCities();
        }
    },
    destroyed() {
        eventHub.$off('cart:update', this.update);
    },
    methods: {
        initData() {
            this.cityId = undefined;
            this.orderData.dist_id = undefined;
        },
        loadCities() {
            this.dataIsLoading(true);
            axios.get(`${base_url}/api/regions/cities`)
                .then((...response_success) => {
                    let response_data = response_success[0].data;
                    try {
                        this.cities = [];
                        response_data.forEach(item => this.cities.push(item));
                        if (this.cities.length > 0) this.cityId = this.cities[0].id;
                    } catch (e) {
                        console.log(e);
                    }
                    this.loadAdminDivision(this.cityId);
                    return;
                })
                .catch((...response_error) => {
                    console.log(response_error);
                    return;
                });
        },
        loadAdminDivision(city_id) {
            if (!this.isBusy) this.dataIsLoading(true);
            axios.get(`${base_url}/api/regions/${city_id}/dists`)
                .then((...response_success) => {
                    let response_data = response_success[0].data;
                    try {
                        this.adminDivisions = [];
                        response_data.forEach(item => this.adminDivisions.push(item));
                        if (this.adminDivisions.length > 0) this.orderData.dist_id = this.adminDivisions[0].id;
                    } catch (e) {
                        console.log(e);
                    }
                    this.dataIsLoading(false);
                    return;
                })
                .catch((...response_error) => {
                    console.log(response_error);
                    return;
                });
        },
        submit() {
            console.log(this.orderData);
            this.dataIsLoading(true);
            axios.post(`${base_url}/api/orders`, this.orderData)
                .then((...response_success) => {
                    let response_data = response_success[0].data;
                    this.dataIsLoading(false);
                    document.write(response_data);
                    // Turbolinks.visit(base_url + '/');
                    return;
                })
                .catch((...response_error) => {
                    console.log(response_error);
                    return;
                });
            console.log('save to server.');
        }
    },
    computed: {
        zipcode() {
            let result;
            if (this.adminDivisions.length) {
                this.adminDivisions.forEach(dist => {
                    if (this.orderData.dist_id === dist.id) result = dist.zip_code;
                });
            }
            return result;
        }
    }
}
</script>

<style scoped>
.homebtn {
    border: solid;
    padding: 10px;
}

.alert-success {
    background-color: #FFEEE8 !important;
    font-weight: bold;
    font-size: 18px;
    color: #666666;
}
</style>>
